// eslint-disable-next-line import/no-cycle
import { IGroupAvatar } from '../../../../../groups/interface';
// eslint-disable-next-line import/no-cycle
import { IExpert } from '../../../view-experts/interface';
import { IContentAvatar } from '../content/interface';

export interface IWaitingMedia {
  fileName: string;
  contentUrl: string;
  thumbnailUrl: string;
  fileType: string;
}
export interface IBadge {
  badgeTitle: string;
  badgeDescription: string;
  badgeImgUrl: string;
  metaData?: Record<string, any>;
}

export enum CertificateTemplate {
  CERT_TEMPLATE_1 = 'CERT_TEMPLATE_1',
  CERT_TEMPLATE_2 = 'CERT_TEMPLATE_2',
  CERT_TEMPLATE_3 = 'CERT_TEMPLATE_3',
}

export enum CertificateValidityUnit {
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export enum CertificateStatus {
  ACTIVE = 'ACTIVE',
  REVOKED = 'REVOKED',
  EXPIRED = 'EXPIRED',
}

export enum CertificateVersion {
  V1 = 'v1',
}

export enum CertificateSessionCompletionFilter {
  NOT_STARTED = 'not_started',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
}

export interface ICertificateLogo {
  title: string;
  logoUrl: string;
}

export interface ICertificateBadge {
  title: string;
  description?: string;
  imageUrl: string;
}

export interface ICertificateSignatory {
  name: string;
  designation: string;
  signatureImageUrl: string;
}

export interface ICertificateValidity {
  value: number;
  unit: CertificateValidityUnit;
}

export interface ICertificate {
  title: string;
  description: string;
  template: CertificateTemplate;
  header: string;
  logos?: ICertificateLogo[];
  badge?: ICertificateBadge;
  signatories?: ICertificateSignatory[];
  validity?: ICertificateValidity;
}

export interface IIssuedCertificate {
  id?: string;
  _id: string;
  refId: string;
  entId: string;
  userId: string;
  sessionId: string;
  userSessionId: string;
  configuration: ICertificate;
  issuedOn: string;
  revokedOn?: string;
  expiresOn: string;
  documentUrl: string;
  status: CertificateStatus;
  version: CertificateVersion;
  revocationReason: string;
  meta: {
    verificationAttempts: number;
  };
  createdAt: string;
  updatedAt: string;
}

export interface IModule {
  key?: string;
  id?: string;
  name: string;
  description: string;
  session: ISessionAvatar[];
  form: ISessionFormAvatar[];
  content: IContentAvatar[];
  badge: IBadge;
  version?: number;
  isUpdated?: boolean;
}

export interface IGoal {
  title: string;
}
export interface IModuleDocument {
  id?: string;
  name: string;
  description: string;
  session: ISessionAvatar[];
  form: ISessionFormAvatar[];
  content: IContentAvatar[];
  badge: IBadge;
  version?: number;
}

export interface IUserSettings {
  allowUpload: boolean;
  allowMessaging: boolean;
}
export interface ISessionForm {
  id: string;
  submission: string;
}

export interface ISessionFormAvatar {
  id: string;
  submission: string;
  formType: string;
  formTitle: string;
  formDescription: string;
  badgeImgUrl: string;
}
export interface IEventLocation {
  from: string;
  to: string;
  address: string;
  description?: string;
  isCancel?: boolean;
}

export interface ISessionFormAvatarWithAction extends ISessionFormAvatar {
  isAdded: boolean;
}
export interface IClass {
  from: string;
  to: string;
  date: string;
}
export interface Frequency {
  frequency: string;
  startDate: string;
  endDate: string;
  startAt: string;
  endAt: string;
  dayOfTheWeek: string;
  dayOfTheMonth: string;
  classes?: IClass[];
  locations?: IEventLocation[];
}
export interface IAvailableTime {
  day: string;
  isAvailable: boolean;
  isAllDay: boolean;
  times: { from: string | null; to: string | null }[];
}

export interface ISessionMeta {
  startDate: string;
  endDate: string;
  liveClassType: string;
}
export interface IRelatedSkills {
  id: string;
  name: string;
}
export interface ISessionAvatar {
  id: string;
  sessionType: string;
  title: string;
  audienceType: string;
  description?: string;
  language?: string;
  fee?: string;
  isActive?: boolean;
  deleted?: boolean;
  currency?: string;
  discount?: string;
  certificate?: ICertificate | null;
  assignedGroups?: {
    id: string;
    groupType: string;
    title: string;
  }[];
}

export interface IInvitation {
  _id: string;
  userEmail: string;
  resourceId: string;
  status: string;
  type: string;
  createdAt: string;
  updatedAt: string;
}
export interface ISessionAvatarWithAction extends ISessionAvatar {
  isAdded: boolean;
}

export interface IInvitedParticipants {
  firstName: string;
  email: string;
}
export interface SessionDocument {
  id: string;
  entId: string;
  expertId: string;
  expert: IExpert;
  isActive: boolean;
  deleted: boolean;
  sessionType: string;
  audienceType: string;
  userSettings: IUserSettings;
  invitePeople: string[];
  invitedParticipants: IInvitedParticipants[];
  password: string;
  courseType: string;
  title: string;
  description: string;
  message: string;
  highlightMedia: IContentAvatar;
  sessionOutcomes: string[];
  relatedSkills: IRelatedSkills[];
  language: string;
  numberOfSessions: number;
  sessionDuration: number;
  waitingRoomMedia: IWaitingMedia;
  numberOfParticipants: number;
  isObserverAllowed: boolean;
  numberOfObservers: number;
  groups: string[];
  media: string[];
  forms: ISessionForm[];
  groupsList: IGroupAvatar[];
  mediaList: IContentAvatar[];
  formsList: ISessionFormAvatar[];
  availableTimes: IAvailableTime[];
  frequency: Frequency;
  fee: string;
  currency: string;
  discount: string;
  subscriberFee: string;
  subscriberCurrency: string;
  subscriberDiscount: string;
  observerFee: string;
  observerCurrency: string;
  observerDiscount: string;
  subscribeObserverFee: string;
  subscribeObserverCurrency: string;
  subscribeObserverDiscount: string;
  invitations: IInvitation[];
  badge: IBadge;
  certificate?: ICertificate | null;
  certificateIssuance?: boolean;
  modules: IModuleDocument[];
  goals: IGoal[];
  sessionMeta: ISessionMeta;
  nextSession: string;
  createdAt: string;
  categories: { id: string; name: string }[];
  prerequisites?: { id: string; title: string }[];
  assignedGroups?: {
    id: string;
    groupType: string;
    title: string;
  }[];
  isSequentialModuleNavigationEnabled: boolean;
  bookedSessions: number;
  bookedObservers: number;
  metaData?: Record<string, any>;
  locations?: IEventLocation[];
  pendingSlots?: {
    slot: {
      from: string;
      to: string;
      date: string;
    };
    meetingId: string;
    location?: {
      address: string;
      description?: string;
    };
  }[];
}

export interface ISessionTypeModalForm {
  sessionType: string;
}
export interface IDeleteSessionConfirmationModalForm {
  message: string;
  linkedSession: ISessionAvatar | undefined;
}
